<template>
  <span class="vsh-help-wrap">
    <b-button
      size="sm"
      variant="outline-secondary"
      title="How to use Vehicle Sync History"
      aria-label="Help"
      @click="show_help = true"
    >
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal
      v-model="show_help"
      title="Using Vehicle Sync History"
      size="lg"
      ok-only
      scrollable
    >
      <div class="vsh-help-body">
        <h4>What this page is</h4>
        <p>
          One row for every vehicle status change made automatically by a sync, whichever
          pair of systems it moved between. It answers "why did this bus come off the board
          on Tuesday" without anyone reading logs.
        </p>
        <p>
          Changes people make by hand are not here — those are on
          <b>Vehicle Status History</b>, which shows the record each change left behind.
        </p>

        <hr/>

        <h4>The syncs</h4>
        <p>Only the ones your account runs appear as chips.</p>
        <ul>
          <li>
            <b>DVIR → Fleetio</b>: an unresolved unsafe DVIR puts the vehicle Out of Service
            in Fleetio, and sets it back to Active once the defect is resolved.
          </li>
          <li>
            <b>Fleetio → TBN</b>: a vehicle Out of Service or In Shop in Fleetio gets a
            blocking service event on the TBN calendar, so dispatch can't assign it. Back to
            active in Fleetio closes the event.
          </li>
          <li><b>DVIR → VSM</b>: a DVIR sets the vehicle's maintenance status on the board.</li>
          <li>
            <b>TBN → VSM</b>: a service event on the TBN calendar shows the vehicle as OOS
            or PM on the board for as long as it runs.
          </li>
          <li>
            <b>MaintainX → TBN</b>: an open MaintainX work order blocks the vehicle on the
            TBN calendar.
          </li>
        </ul>

        <hr/>

        <h4>Reading a row</h4>
        <ul>
          <li><b>Sync</b> names the pair of systems, in the same colour as its chip.</li>
          <li>
            <b>Change</b> is what was done: a status set, or a calendar block created,
            extended, or closed.
          </li>
          <li>
            <b>From / To</b> is the value before and after. A row with no "from" is a block
            being created rather than a value being changed.
          </li>
          <li><b>Detail</b> carries whatever the sync recorded — the DVIR, the work order, the event id.</li>
        </ul>

        <hr/>

        <h4>Narrowing it</h4>
        <ul>
          <li>
            <b>Range</b> picks a window ending today; <b>From</b> and <b>To</b> set any
            window, and the arrows nudge it by a day or a whole window at a time.
          </li>
          <li>
            The <b>Sources</b> chips carry a count for the loaded range and filter what's
            already on screen, so they're immediate. <b>All</b> clears the choice.
          </li>
          <li>The vehicle select reloads from the server.</li>
        </ul>

        <hr/>

        <h4>What isn't here</h4>
        <p>
          Rows are written as the syncs run, so nothing exists from before the audit trail
          was turned on for your account. An empty range means no sync changed anything —
          not that a change went unrecorded. The
          <i class="fa fa-download"></i> icon downloads a CSV of the current range and
          source filter.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
// how-to modal for the sync audit trail, following the erm_*_help / actuals_*_help house
// pattern (info-icon button + ok-only scrollable modal).
export default {
  name: 'vsm_sync_history_help',
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.vsh-help-body h4 { font-size: 1.05rem; margin-top: 4px; }
.vsh-help-body p, .vsh-help-body li { font-size: 0.95rem; }
.vsh-help-body li { margin-bottom: 6px; }
</style>
